import { FileManagerTypes, FolderDetailsType } from "./fileManagerTypes";

export const initialState: FileManagerTypes = {
  fetching: false,
  uploadFetching: false,
  success: null,
  uploadSuccess: null,
  error: null,
  statusCode: null,
  childFolders: [],
  childFolderCount: null,
  isParrentHide: null,
  childFiles: [],
  childFilesCount: 0,
  currentDirPath: [],
  currentFolderDetails: {} as FolderDetailsType,
  uploadFileData: {},
  totalCount: 0,
};
